export const CATEGORY = {
  TECH_BUGS: 'tech_bugs',
  ORDER_SYNC: 'order_sync',
  APP_ISSUE: 'app_issue',
  EDIT_PROFILE: 'edit_profile',
  LOGIN_ISSUES_WEBSITE: 'login_issues_website',
  MEDICAL_ESCALATIONS: 'medical_escalations',
  HAIRFALL_ISSUE: 'hairfall_issue',
  CONSTIPATION_ISSUE: 'constipation_issue',
  DANDRUFF_ISSUE: 'dandruff_issue',
  HEALTH_ISSUE: 'health_issue',
  ITCHING_ISSUE: 'itching_issue',
  PRODUCT_REACTION_ISSUE: 'product_reaction_issue',
  SEXUAL_ISSUE: 'sexual_issue',
  GASTRIC_ISSUE: 'gastric_issue',
  OTHER_ISSUE: 'other_issue',
  MEDICAL_DOCUMENT: 'medical_document',
  FOLLOW_UP: 'follow_up',
  DOCTOR_FOLLOWUP:'follow_up_call',
  FIVE_MONTHS_NO_RESULTS: 'five_months_no_results',
  DETERIORATION: 'deterioration',
  DOCTOR_CALL: 'doctor_call',
  ORDER_RELATED: 'order_related',
  ORDER_CANCELLATION: 'order_cancellation',
  REVERSE_PICK_UP: 'reverse_pick_up',
  DAMAGED_PRODUCT: 'damaged_product',
  MISSING_PRODUCT: 'missing_product',
  MISMATCH_PRODUCT: 'mismatch_product',
  DELIVERY_ISSUES: 'delivery_Issues',
  REATTEMPT_REQUEST: 'reattempt_request',
  INITIATE_RTO: 'initiate_rto',
  TRACKING_LINK_NOT_UPDATED: 'tracking_link_Not_updated',
  WRONG_TRACKING_STATUS: 'wrong_tracking_status',
  AMOUNT_PAID_NO_ORDER: 'amount_paid_no_order',
  PAYMENTS: 'payments',
  PAYMENTS_ISSUE: 'payments_issue',
  ORDER_RELATED_REFUNDS: 'order_related_refunds',
  PAYMENT_FAILURE: 'payment_failure',
  REFERRAL_CODE: 'referral_code',
  FIVE_MONTH_MONEY_BACK: 'five_month_money_back',
  CUSTOMER_COMPLAINTS: 'customer_complaints',
  FIVE_MONTH_MONEY_BACK: 'five_month_money_back',
  COACH_SERVICE: 'coach_service',
  ANGRY_CUSTOMER: 'angry_customer',
  NO_RESULTS_TRAYA: 'no_results_traya',
  NEGATIVE_REVIEW: 'negative_review',
  SLOT_MISSED: 'slot_missed',
  SLOT_NOT_CATERED: 'slot_not_catered',
  CUSTOMER_OTHERS: 'customer_others',
  JAGDKASGDKGAK: 'jagdkasgdkgak',
  ASKDAKSHJAKS: 'askdakshjaks',
  ASDJNASD: 'asdjnasd',
  AAAAAAADD: 'aaaaaaadd',
  BBBBBB: 'bbbbbb',
  MEDICAL_DOCUMENT: 'medical_document',
  RETURN_REQUEST: 'return_request',
  TESTING_SUBCATEGORY_TWO: 'testing_subcategory_two',
  PRODUCT_RELATED_QUALITY_ISSUES: 'product_related_quality_issues',
  HAIR_RAS: 'hair_ras',
  NEGATIVE_REVIEWS_ORM: 'negative_reviews_orm',
  HEALTH_TATVA: 'health_tatva',
  SCALP_OIL_BOOSTER_OILS: "scalp_oil_'booster_oils'",
  GUTT_SHUDDHI: 'gutt_shuddhi',
  NASAL_GRIT: 'nasal_grit',
  DIGEST_BOOST: 'digest_boost',
  CONSTI_CLEAR: 'consti_clear',
  CHOLEST_VATI: 'cholest_vati',
  PCOS_SANTULAN: 'pcos_santulan',
  THYRO_SANTULAN: 'thyro_santulan',
  HER_SANTULAN_: 'her_santulan_',
  MOM_SANTULAN: 'mom_santulan',
  MINOXIDIL_2: 'minoxidil_2%',
  MINOXIDIL_5: 'minoxidil_5%',
  ANTI_DANDRUFF_SHAMPOO: 'anti_dandruff_shampoo',
  ANTI_DANDRUFF_NIGHT_LOTION: 'anti_dandruff_night_lotion',
  DEFENCE_SHAMPOO: 'defence_shampoo',
  RECAP_SERUM: 'recap_serum',
  HAIR_VITAMIN: 'hair_vitamin',
  CUTICLE_DAMAGE_RANGE: 'cuticle_damage_range',
  NOURISH_HAIR_OIL_: 'nourish_hair_oil_',
  NEW_PRODUCT_SUGGESTION_: 'new_product_suggestion_',
  TESTINGONE: 'testingone',
  ADLNKADS: 'adlnkads',
  TESTINGONETWO: 'testingonetwo',
  TESTINGTWO: 'testingtwo',
  AFJSFKBSF: 'afjsfkbsf',
  TESTING_ONE: 'testing_one',
  TESTING_AGAIN_ONE: 'testing_again_one',
  TESTING_THREE: 'testing_three',
  TESTING_THREE_TWO: 'testing_three_two',
  TESTING_FAQ_ASSIGNEE_SUBCATEGORY: 'testing_faq_assignee_subcategory',
  FOLLOW_UP: 'follow_up',
  TESTING_CATEGORY: 'testing_category',
  TESTING_SUBCATEGORY: 'testing_subcategory',
  TESTING_TWIO_: 'testing_twio_',
  AUTO_PREPAID_RTO: 'auto_prepaid_rto',
  AUTO_ORDER_CANCELLATION_INITIATED: 'auto_order_cancellation_initiated',
  COMMUNITY_ESCALATION: 'community_escalation'
};

export const categories = {
  [CATEGORY.TECH_BUGS]: 'Tech Issues',
  [CATEGORY.ORDER_SYNC]: 'Order sync',
  [CATEGORY.APP_ISSUE]: 'App issue ',
  [CATEGORY.EDIT_PROFILE]: 'Edit profile',
  [CATEGORY.LOGIN_ISSUES_WEBSITE]: 'Login Issue on website',
  [CATEGORY.MEDICAL_ESCALATIONS]: 'Medical Escalations',
  [CATEGORY.HAIRFALL_ISSUE]: 'Hairfall',
  [CATEGORY.CONSTIPATION_ISSUE]: 'Constipation',
  [CATEGORY.DANDRUFF_ISSUE]: 'Dandruff',
  [CATEGORY.HEALTH_ISSUE]: 'Health conditions',
  [CATEGORY.ITCHING_ISSUE]: 'Itching',
  [CATEGORY.PRODUCT_REACTION_ISSUE]: 'Product Reaction ',
  [CATEGORY.SEXUAL_ISSUE]: 'Sexual issue',
  [CATEGORY.GASTRIC_ISSUE]: 'Gastric issues',
  [CATEGORY.OTHER_ISSUE]: 'Other Medical Issues',
  [CATEGORY.MEDICAL_DOCUMENT]: 'Medical Document',
  [CATEGORY.FOLLOW_UP]: 'Follow Up',
  [CATEGORY.FIVE_MONTHS_NO_RESULTS]: 'Five Months No Results',
  [CATEGORY.DETERIORATION]: 'Deterioration',
  [CATEGORY.DOCTOR_CALL]: 'Doctor Call',
  [CATEGORY.ORDER_RELATED]: 'Order Related',
  [CATEGORY.ORDER_CANCELLATION]: 'Order Cancellation',
  [CATEGORY.REVERSE_PICK_UP]: 'Reverse Pick Up',
  [CATEGORY.DAMAGED_PRODUCT]: 'Damaged Product',
  [CATEGORY.MISSING_PRODUCT]: 'Missing Product ',
  [CATEGORY.MISMATCH_PRODUCT]: 'Mismatch Product',
  [CATEGORY.DELIVERY_ISSUES]: 'Delivery Issues',
  [CATEGORY.REATTEMPT_REQUEST]: 'Reattempt Request',
  [CATEGORY.INITIATE_RTO]: 'Initiate RTO',
  [CATEGORY.TRACKING_LINK_NOT_UPDATED]: 'Tracking Link Not Updated',
  [CATEGORY.WRONG_TRACKING_STATUS]: 'Incorrect Tracking Status',
  [CATEGORY.AMOUNT_PAID_NO_ORDER]: 'Amount Paid But Not Handed Over',
  [CATEGORY.PAYMENTS]: 'Payment Issue',
  [CATEGORY.PAYMENTS_ISSUE]: 'Payment Issue',
  [CATEGORY.ORDER_RELATED_REFUNDS]: 'Order Related Refunds',
  [CATEGORY.PAYMENT_FAILURE]: 'Payment Failure No Order Placed',
  [CATEGORY.REFERRAL_CODE]: 'Referall Code',
  [CATEGORY.FIVE_MONTH_MONEY_BACK]: 'Five Month Money Back',
  [CATEGORY.CUSTOMER_COMPLAINTS]: 'Customer Complaints',
  [CATEGORY.FIVE_MONTH_MONEY_BACK]: 'Five month money back',
  [CATEGORY.COACH_SERVICE]: 'Coach service',
  [CATEGORY.ANGRY_CUSTOMER]: 'Angry Customer',
  [CATEGORY.NO_RESULTS_TRAYA]: 'No Result with Traya',
  [CATEGORY.NEGATIVE_REVIEW]: 'Negative Review ',
  [CATEGORY.SLOT_MISSED]: 'Slot Completely Missed',
  [CATEGORY.SLOT_NOT_CATERED]: 'Slot not Catered On Time',
  [CATEGORY.CUSTOMER_OTHERS]: 'Other Customer Issue',
  [CATEGORY.JAGDKASGDKGAK]: 'Jagdkasgdkgak',
  [CATEGORY.ASKDAKSHJAKS]: 'Askdakshjaks',
  [CATEGORY.ASDJNASD]: 'Asdjnasd',
  [CATEGORY.AAAAAAADD]: 'Aaaaaaadd',
  [CATEGORY.BBBBBB]: 'Bbbbbb',
  [CATEGORY.MEDICAL_DOCUMENT]: 'Medical Document',
  [CATEGORY.RETURN_REQUEST]: 'Return Request',
  [CATEGORY.TESTING_SUBCATEGORY_TWO]: 'Testing Subcategory Two',
  [CATEGORY.PRODUCT_RELATED_QUALITY_ISSUES]: 'Product Related Quality Issues',
  [CATEGORY.HAIR_RAS]: 'Hair Ras',
  [CATEGORY.NEGATIVE_REVIEWS_ORM]: 'Negative Reviews ORM',
  [CATEGORY.HEALTH_TATVA]: 'Health Tatva',
  [CATEGORY.SCALP_OIL_BOOSTER_OILS]: 'Scalp Oil / Booster Oils',
  [CATEGORY.GUTT_SHUDDHI]: 'Gutt Shuddhi',
  [CATEGORY.NASAL_GRIT]: 'Nasal Grit',
  [CATEGORY.DIGEST_BOOST]: 'Digest Boost',
  [CATEGORY.CONSTI_CLEAR]: 'Consti Clear',
  [CATEGORY.CHOLEST_VATI]: 'Cholest Vati',
  [CATEGORY.PCOS_SANTULAN]: 'PCOS Santulan',
  [CATEGORY.THYRO_SANTULAN]: 'Thyro Santulan',
  [CATEGORY.HER_SANTULAN_]: 'Her Santulan ',
  [CATEGORY.MOM_SANTULAN]: 'Mom Santulan',
  [CATEGORY.MINOXIDIL_2]: 'Minoxidil 2%',
  [CATEGORY.MINOXIDIL_5]: 'Minoxidil 5%',
  [CATEGORY.ANTI_DANDRUFF_SHAMPOO]: 'Anti-Dandruff Shampoo',
  [CATEGORY.ANTI_DANDRUFF_NIGHT_LOTION]: 'Anti-Dandruff Night Lotion',
  [CATEGORY.DEFENCE_SHAMPOO]: 'Defence Shampoo',
  [CATEGORY.RECAP_SERUM]: 'Recap Serum',
  [CATEGORY.HAIR_VITAMIN]: 'Hair Vitamin',
  [CATEGORY.CUTICLE_DAMAGE_RANGE]: 'Cuticle Damage Range',
  [CATEGORY.NOURISH_HAIR_OIL_]: 'Nourish Hair Oil ',
  [CATEGORY.NEW_PRODUCT_SUGGESTION_]: 'New Product Suggestion ',
  [CATEGORY.TESTINGONE]: 'TestingOne',
  [CATEGORY.ADLNKADS]: 'Adlnkads',
  [CATEGORY.TESTINGONETWO]: 'Testingonetwo',
  [CATEGORY.TESTINGTWO]: 'TestingTwo',
  [CATEGORY.AFJSFKBSF]: 'Afjsfkbsf',
  [CATEGORY.TESTING_ONE]: 'Testing One',
  [CATEGORY.TESTING_AGAIN_ONE]: 'Testing Again One',
  [CATEGORY.TESTING_THREE]: 'Testing Three',
  [CATEGORY.TESTING_THREE_TWO]: 'Testing THree Two',
  [CATEGORY.TESTING_FAQ_ASSIGNEE_SUBCATEGORY]: 'Testing FAQ Assignee Subcategory',
  [CATEGORY.FOLLOW_UP]: 'Follow Up',
  [CATEGORY.TESTING_CATEGORY]: 'Testing Category',
  [CATEGORY.TESTING_SUBCATEGORY]: 'Testing Subcategory',
  [CATEGORY.TESTING_TWIO_]: 'Testing Twio ',
  [CATEGORY.AUTO_PREPAID_RTO]: 'Auto Prepaid RTO',
  [CATEGORY.AUTO_ORDER_CANCELLATION_INITIATED]: 'Auto Order Cancellation Initiated',
  [CATEGORY.COMMUNITY_ESCALATION]: 'community Escalation',
  [CATEGORY.DOCTOR_FOLLOWUP]: 'Follow Up Call'
};

export const TICKET_STATUS = {
	OPEN: 'Open',
	PENDING: 'Pending',
	RESOLVED: 'Resolved',
	CLOSED: 'Closed'
};

export const TICKET_STATUS_CODE = {
	OPEN: 2,
	PENDING: 3,
	RESOLVED: 4,
	CLOSED: 5
};
export const CUSTOMER_COMPLAINTS_SUBCATS = [CATEGORY.CUSTOMER_OTHERS, CATEGORY.SLOT_NOT_CATERED, CATEGORY.SLOT_MISSED, CATEGORY.NEGATIVE_REVIEW, CATEGORY.NO_RESULTS_TRAYA, CATEGORY.ANGRY_CUSTOMER, CATEGORY.COACH_SERVICE, CATEGORY.FIVE_MONTH_MONEY_BACK, CATEGORY.COMMUNITY_ESCALATION];

export const optionsData = [
  { label: "Dr Rashi Soni", value: "662a58a9-9e5a-4b62-85cc-eaa1b1975920", },
  { label: "Dr Divyashree R", value: "7a013341-7952-4ea9-a354-6cbad20615ad", },
  { label: "Dr Shriya saha", value: "fdc354a6-d73e-4b2a-8277-ac1325a949e6", },
  { label: "Dr Jessica Dodani", value: "b90ccaac-9a15-461a-91cb-c2e04ff18dc2" },
  { label: "Dr Ramoli Nimbalkar", value: "b0c3a44a-b3e2-4c94-8fa1-244a91e50f8a" },
  { label: "Dr Divyesh Jain", value: "0ba28a3d-3088-4e53-9e05-934425312df0", },
  { label: "Dr Harshal", value: "a1be1e1d-5ac6-4d25-8ebb-7af5165f9ebc" },
  { label: "Dr Reena Majithia", value: "995d3b07-562b-4f41-8320-173b4fe7d1c1" },
  { label: "Dr Avtarsinh Vaghela", value: "e7ed7c58-7cca-4c0e-ba60-5fad87be6b03" },
  { label: "Dr Vijayalaxmi", value: "f7620b9d-396d-4256-90e0-27c5cf49da99" },
  { label: "Dr Ritu Parna", value: "e1987ca8-11b0-4650-8d31-4b4d685bac10"},
  { label: "Dr Deepak Naik", value: "3b94ea51-f9e5-49c0-88d4-4fca0d130980"},
  { label: "Dr Rajkumar Pal", value: "e8c96bea-41f2-46e6-9d7d-3a02d1792066"},
  { label: "Dr Shama Naaz", value: "e16f4916-a8e8-4e6e-87ef-27c241cf17df"},
  { label: "Dr Keerti", value: "68526509-9b0c-4360-b999-87539d192da0"},
  { label: "Dr Asna Hassan", value: "68e5e4b7-33e2-4a0c-aa37-1ae11bf043bf"},
  { label: "Dr Chintaman Suvarna", value: "1a7671fa-c5d0-4334-9205-5ffd3346b3e0"},
  { label: "Dr Nandini Shetty", value: "24154cc6-6fa3-47d3-9a3d-e0ca8b3c9d66"},
  { label: "Dr Haarika Sadhu", value: "01cfe6f5-a7c6-4cd8-85fc-64f6c2054ba1"},
  { label: "Dr Sukrutha", value: "f5f03c1f-c9cb-4420-b2e5-cc4c2534458f"},
  { label: "Dr Manali", value: "70653eed-72b1-4d8e-9d78-672bef755c96"},
  { label: "Dr. Manish", value: "a21680cd-6e0d-41b7-831a-0db6e5f7ef8d"},
  { label: "Dr Mariya", value: "07751594-0986-4f38-a887-3276cdc2dabd"},
  { label: "Dr Siddhi", value: "131cce49-6be3-4ccf-b530-05dd7625395c"},
  { label: "Dr Ketaki", value: "c41f23e2-fe10-4fe9-9ca5-04ed420b667f"},
  { label:"Dr Darshana_ayurveda", value: "c5108066-1d87-4195-897d-4b65aef3221e"},
  { label:"Dr Oshin Rajeev_ayurveda", value: "047d92c8-3dc8-4e74-8de2-85ea1b1246a0"},
  { label:"Dr Afreen Sayyed_ayurveda", value: "8f0cc618-54cc-47bf-b3cd-4497b2ea4bcf"},
  { label:"Dr Aisha Parveen", value: "d7324023-6403-4bb5-857a-20d489ee09a7"},
  { label:"Dr Deepika Jain", value: "147cf4e2-bacb-438d-a032-ae82c0771a99"},
  { label:"Dr Sharan Keshetty", value: "8861fd4d-a885-4931-916d-0c0824ab93ed"},
  { label:"Dr Shivani Dawas", value: "78f98d09-b065-4aa5-add6-dce63d6abea8"},
  { label:"Dr Suhasini Goyal", value: "c19c91cc-5150-4fc4-b92b-bffb11e1bd1c"},
  { label:"Dr Swapnil Hippargi", value: "4cefe916-cb16-4caa-99d6-4846f7708bb5"},
  { label:"Dr Shashank Dhatwalia", value: "dbff8b5e-a11b-487f-a057-cfbfd90b9e3b"},
  { label:"Dr Atul Soni", value: "d4b6d014-e2f1-4ad0-80b3-2a23096aa766"},
  { label:"Dr Minakshi Bisen", value: "4e173dad-ed02-4442-8e93-ba47bf7fd1aa"},
  { label:"Dr Sakshi", value: "5909af86-3a7f-4e7a-acf7-08cfa45f4e71"},
  { label:"Dr Deepali Rai", value: "d3f97f37-60e4-4f0e-a212-33d13e63b2af"},
  { label:"Dr Devyani Baunthiyal", value: "7068e9fe-39ed-4e95-920b-3b959a535b36"},
  { label:"Dr Jaineet Dhillon", value: "b3e7da09-18a9-42e1-9bed-e9b73c17ad0b"},
  { label:"Dr Pratima Majgaonkar", value: "abeda301-700b-4696-8f8f-73bfd4930f1a"},
  { label:"Dr Vishali Vasu", value: "11d59723-1ebe-428d-be11-f5fcaaacef78"},
  { label:"Dr Anamika Thakur", value: "a532b566-5137-42b1-aa06-8b993c025ef0"},
  { label:"Dr Dhriti Sood", value: "679602f0-201a-447f-aa23-06e7fb97bb57"},
  { label:"Dr Lakshmi Somu", value: "d461e3a3-e2db-49cb-9746-0165b02fb8eb"},
  { label:"Dr Priyanka Soni", value: "2b370a9a-e1b0-4630-92b6-9c489a6728ed"},
  { label:"Dr Sushmita Singh", value: "c885b4c8-5208-4115-be57-91d90c2df4fe"},
  { label:"Dr Yashvi Doshi", value: "f56a978f-1b5d-4785-abf8-e688a78ca93b"},
  { label:"Dr Aayushi", value: "214b5b30-9e58-4978-babc-67505b602eb4"},
  { label:"Dr Aditi", value: "84363001-5e24-41c8-9e94-87c899108ecf"},
  { label:"Dr Kishan", value: "7305747a-5bef-4ab3-b426-05d5bd2dd818"},
  { label:"Dr Mehak", value: "dd83c135-7bf1-4e3b-a487-7e38fa24a366"},
  { label:"Dr Pavan", value: "79978721-fd5e-476d-9e73-43ee153548df"},
  { label:"Dr Pranjali", value: "f17374ae-0d8c-44ff-8cea-d0dc97bfa895"},
  { label:"Dr Sasi", value: "f32d41cc-53db-403e-b412-6f39a9ee305f"},
  { label:"Dr Tanmay Badlawala", value: "e5833dec-19f8-4751-9050-4fa207f4e151"},
  { label:"Dr Anshita Mishra", value: "5e8e622b-afd9-46cf-b1d7-08ad1c0a661f"},
  { label:"Dr Mahima Chaudhry", value: "a9782aef-00f1-44a5-b8eb-50630f45434c"},
  { label:"Dr Shreya Rawat", value: "794c2071-d286-4727-90e4-98e2808189f8"},
  { label:"Dr Shiv Singh Shekhawat", value: "66e03a68-5caf-4f86-bbf3-633c4a66b3f6"},
  { label:"Dr Amaan Kapadia", value: "8514116b-5399-4581-abd6-8f23a2b5db22"},
  { label:"Dr Aryan Babbar", value: "321c89f2-bbf4-46a4-baa9-22365815af0e"},
  { label:"Dr Anshika Verma", value: "2aa568d5-6796-4864-898b-4922a2204e74"},
  { label:"Dr Madhuri Prasad", value: "841e1da6-8e24-48f9-932c-4740452f9f38"},
  { label:"Dr Siddhi Bhartiya", value: "938ba5f0-86d2-4e0c-a4be-ae7a95b1c7cf"},
  { label:"Dr Yash Choudhary", value: "402294d0-654a-46f9-80fc-02c0a8e2cb2e"}
];